import { Component, OnInit, AfterViewInit } from '@angular/core';

import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';

@Component({
  selector: 'member-clients-app',
  templateUrl: './clients-app.component.html',
  styles: [],
  standalone: false
})
export class ClientsAppComponent implements OnInit, AfterViewInit {
  constructor(
    private appService: SondermindApplicationService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.appService.pageLoaded = true;
  }
}
